import { render, staticRenderFns } from "./DeleteBlock.vue?vue&type=template&id=e7b05750&scoped=true"
import script from "./DeleteBlock.vue?vue&type=script&lang=js"
export * from "./DeleteBlock.vue?vue&type=script&lang=js"
import style0 from "./DeleteBlock.vue?vue&type=style&index=0&id=e7b05750&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_6szsw7whnsew6zajutnmcgkloi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b05750",
  null
  
)

export default component.exports